import { render } from "./DentalBillingList.vue?vue&type=template&id=767340b2&scoped=true"
import script from "./DentalBillingList.vue?vue&type=script&lang=js"
export * from "./DentalBillingList.vue?vue&type=script&lang=js"

import "./DentalBillingList.vue?vue&type=style&index=0&id=767340b2&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767340b2"]])

export default __exports__